import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const PackagesPage = () => {
  const [photographerPkgs, setPhotographerPkgs] = useState([]);
  const [dealerPkgs, setDealerPkgs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axios.get(`${API_URL}/api/packages?type=photographer`),
      axios.get(`${API_URL}/api/packages?type=dealer`)
    ]).then(([p, d]) => {
      setPhotographerPkgs(p.data);
      setDealerPkgs(d.data);
    }).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={s.page}><p style={{ textAlign: 'center', color: '#fff' }}>Loading...</p></div>;

  return (
    <div style={s.page}>
      <div style={s.hero}>
        <h1 style={s.heroTitle}>Event Photo Packages</h1>
        <p style={s.heroSub}>Choose a plan that works for you</p>
      </div>

      <div style={s.container}>
        {/* Photographer Packages */}
        <div style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.sectionIcon}>📷</span>
            <div>
              <h2 style={s.sectionTitle}>For Photographers</h2>
              <p style={s.sectionSub}>Individual event credits. Buy and use anytime.</p>
            </div>
          </div>
          <div style={s.grid}>
            {photographerPkgs.map(pkg => (
              <div key={pkg.id} style={s.card}>
                <p style={s.cardName}>{pkg.name}</p>
                <p style={s.cardEvents}>{pkg.events_count}</p>
                <p style={s.cardEventsLabel}>Event{pkg.events_count > 1 ? 's' : ''}</p>
                <p style={s.cardPrice}>₹{(pkg.price_paise / 100).toFixed(0)}</p>
                <p style={s.cardPer}>₹{Math.round(pkg.price_paise / pkg.events_count / 100)} per event</p>
                <Link to="/signup" style={s.cardBtn}>Get Started</Link>
              </div>
            ))}
          </div>
        </div>

        {/* Dealer Packages */}
        <div style={{ ...s.section, marginTop: '3rem' }}>
          <div style={s.sectionHeader}>
            <span style={s.sectionIcon}>🤝</span>
            <div>
              <h2 style={s.sectionTitle}>For Dealers</h2>
              <p style={s.sectionSub}>Buy in bulk. Resell to photographers in your network.</p>
            </div>
          </div>
          <div style={s.grid}>
            {dealerPkgs.map(pkg => (
              <div key={pkg.id} style={{ ...s.card, borderColor: '#533483' }}>
                <p style={s.cardName}>{pkg.name}</p>
                <p style={{ ...s.cardEvents, color: '#533483' }}>{pkg.events_count}</p>
                <p style={s.cardEventsLabel}>Events</p>
                <p style={s.cardPrice}>₹{(pkg.price_paise / 100).toFixed(0)}</p>
                <p style={s.cardPer}>₹{Math.round(pkg.price_paise / pkg.events_count / 100)} per event</p>
                <Link to="/dealer/signup" style={{ ...s.cardBtn, background: 'linear-gradient(135deg, #0f3460, #533483)' }}>Become a Dealer</Link>
              </div>
            ))}
          </div>
        </div>

        <div style={s.footer}>
          Already have an account? <Link to="/login" style={s.link}>Sign in</Link>
        </div>
      </div>
    </div>
  );
};

const s = {
  page: { minHeight: '100vh', background: '#f0f4f8', fontFamily: "'Segoe UI', system-ui, sans-serif" },
  hero: { background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)', color: '#fff', textAlign: 'center', padding: '4rem 2rem 3rem' },
  heroTitle: { margin: '0 0 0.5rem', fontSize: '2.25rem', fontWeight: 800 },
  heroSub: { margin: 0, opacity: 0.8, fontSize: '1.1rem' },
  container: { maxWidth: 900, margin: '0 auto', padding: '3rem 1.5rem' },
  section: {},
  sectionHeader: { display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' },
  sectionIcon: { fontSize: '2rem' },
  sectionTitle: { margin: 0, fontSize: '1.4rem', fontWeight: 800, color: '#1a1a2e' },
  sectionSub: { margin: '0.25rem 0 0', color: '#888', fontSize: '0.9rem' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.25rem' },
  card: { background: '#fff', borderRadius: '1.25rem', padding: '2rem 1.5rem', textAlign: 'center', boxShadow: '0 4px 16px rgba(0,0,0,0.08)', border: '2px solid #4f46e5' },
  cardName: { margin: '0 0 1rem', fontWeight: 700, color: '#555', fontSize: '0.875rem', textTransform: 'uppercase', letterSpacing: '0.05em' },
  cardEvents: { margin: 0, fontSize: '3rem', fontWeight: 800, color: '#4f46e5', lineHeight: 1 },
  cardEventsLabel: { margin: '0.25rem 0 1rem', color: '#888', fontSize: '0.875rem' },
  cardPrice: { margin: '0 0 0.25rem', fontSize: '1.75rem', fontWeight: 800, color: '#1a1a2e' },
  cardPer: { margin: '0 0 1.5rem', color: '#999', fontSize: '0.8rem' },
  cardBtn: { display: 'block', padding: '0.75rem', background: 'linear-gradient(135deg, #1a1a2e, #4f46e5)', color: '#fff', borderRadius: '0.75rem', textDecoration: 'none', fontWeight: 700, fontSize: '0.9rem' },
  footer: { textAlign: 'center', marginTop: '3rem', color: '#888', fontSize: '0.9rem' },
  link: { color: '#4f46e5', fontWeight: 600, textDecoration: 'none' }
};

export default PackagesPage;
